import React, { useEffect, useState } from "react";
import { Button, Menu } from "antd";

import { useLocation, useNavigate } from "react-router-dom";

import { LogoutOutlined } from "@ant-design/icons";
import { LuLayoutDashboard } from "react-icons/lu";
import { logout } from "../../api/auth";
import { LiaBlogSolid } from "react-icons/lia";
import { IoSettingsOutline } from "react-icons/io5";

const SiderMenu = ({ visible, setVisible }) => {
  const headerHeight = 83;
  const footerHeight = 70;
  const { pathname } = useLocation();
  const iconSize = 18;

  const getActiveKey = () => {
    switch (pathname) {
      case "/dashboard": {
        return ["1"];
      }
      case "/blog": {
        return ["2"];
      }
      case "/settings": {
        return ["3"];
      }

      default:
        return ["1"];
    }
  };
  const [active, setActive] = useState(getActiveKey);
  const navigate = useNavigate();

  const handleMenu = (event) => {
    visible && setVisible && setVisible(false);
    switch (event.key) {
      case "1":
        navigate("/dashboard");
        break;
      case "2":
        navigate("/blog");
        break;
      case "3":
        navigate("/settings");
        break;

      default:
        navigate("/dashboard");
    }
  };

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  useEffect(() => {
    setActive(getActiveKey());
  }, [pathname]);

  return (
    <>
      <div className="sider_top" style={{ height: `${headerHeight}px` }}>
        <img src={require("../../assets/images/logo.png")} alt={"Logo"} />
      </div>
      <Menu
        theme="dark"
        mode="inline"
        defaultSelectedKeys={active}
        selectedKeys={active}
        onClick={handleMenu}
        style={{
          height: `calc(100vh - (${headerHeight + footerHeight}px))`,
        }}
        items={[
          {
            key: "1",
            icon: <LuLayoutDashboard size={iconSize} />,
            label: "Dashboard",
          },
          {
            key: "2",
            icon: <LiaBlogSolid size={iconSize} />,
            label: "Blog",
          },
          {
            key: "3",
            icon: <IoSettingsOutline size={iconSize} />,
            label: "Settings",
          },
        ]}
      />
      <div className="sider_bottom" style={{ height: `${footerHeight}px` }}>
        <Button
          type="primary"
          style={{ width: "100%" }}
          icon={<LogoutOutlined />}
          onClick={handleLogout}
        >
          Logout
        </Button>
      </div>
    </>
  );
};

export default SiderMenu;
